// extracted by mini-css-extract-plugin
module.exports = {"container":"NmckGroup_container__W5QoW","frame":"NmckGroup_frame__3ghbS","spin":"NmckGroup_spin__39nui"};